import type { ReactNode } from 'react';
import useAuth from '@/auth/application/useAuth';

import { useUmNotificationsRealtime } from '@/userManagement/application/adapters/umContext/useUmNotificationsRealtime';

/**
 * Subscribes to UM notification SignalR events app-wide on the shared ClientHub
 * connection so managers receive bell updates without visiting UM first or refreshing.
 */
export function UmNotificationsRealtimeProvider({ children }: { children: ReactNode }) {
  const { isLoggedIn } = useAuth();
  useUmNotificationsRealtime(isLoggedIn);
  return children;
}
